import { Divider, Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { EInvoicingCashedBanner } from '@features/eInvoicing/elements/EInvoicingCashedBanner'

import { useAttachmentPreviewModal } from '../../context/attachmentPreviewModalContext'
import { AttachmentDetailsFooter } from './elements/AttachmentDetailsFooter'
import { BillDetails } from './elements/BillDetails'
import { DescriptionArea } from './elements/DescriptionArea'
import { FileDetails } from './elements/FileDetails'
import { ReceiptSyncStatusSection } from './elements/ReceiptTransferStatusSection'
import * as Styled from './styles'

export const AttachmentDetails = (): ReactElement => {
  const { isEInvoicingOnly, isShoeboxReadOnly, eInvoiceStatus } = useAttachmentPreviewModal()

  return (
    <Styled.AttachmentDetailsWrapper>
      <Flex flexDirection="column" gap={Spacing.S16} flexGrow={1}>
        <EInvoicingCashedBanner status={eInvoiceStatus} />
        <FileDetails />
        <Divider />
        <BillDetails />
        {isShoeboxReadOnly && <ReceiptSyncStatusSection />}
        {!isEInvoicingOnly && !isShoeboxReadOnly && (
          <>
            <Divider />
            <DescriptionArea />
          </>
        )}
        <AttachmentDetailsFooter />
      </Flex>
    </Styled.AttachmentDetailsWrapper>
  )
}
